import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';

import { useSelectedOrCurrentYear } from '../../../hooks/useYears';

export const SettingButton = () => {
  const year = useSelectedOrCurrentYear();

  return (
    <Menu as="div" className="relative">
      <MenuButton
        className={`flex gap-2 px-2 py-1 rounded hover:bg-gray-100/20 text-white shadow border-2 border-white`}
      >
        <Icon.Settings className="self-center hover:animate-spin" size={18} />
        設定
      </MenuButton>
      <MenuItems className="absolute flex flex-col items-start gap-2 mt-2 right-0 w-52 p-2 rounded border-2 border-darkblue_70 bg-white text-darkblue_100">
        <MenuItem>
          <Link to={`/setting`} className="hover:underline">
            設定
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`${year}/csv-pattern`} className="hover:underline">
            CSV出力パターン管理
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`${year}/csv-download`} className="hover:underline">
            CSVダウンロード管理
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/hospital`} className="hover:underline">
            病院管理
          </Link>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};
